export default defineNuxtRouteMiddleware(async (to) => {
  const auth = useAuthStore();

  // Add a small delay to ensure session cookies are properly available
  // This is especially important after OAuth redirects
  if (import.meta.client) {
    await new Promise((resolve) => setTimeout(resolve, 100));
  }

  const isAuth = await auth.isAuthenticated();
  if (!isAuth) {
    return navigateTo("/login");
  }

  if (to.path.startsWith("/settings/billing") && auth.user?.role !== "owner") {
    return navigateTo("/settings/", { replace: true });
  }
});
